// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"538ade59","732":"caa3ffff","977":"4245b7e6"}[chunkId] + ".chunk.js";
};